/**
 * i18n de Costos y stock (v3) — área COMPRA (Cargar compra / Revisar precios), CONTAR, PÉRDIDA y ACTIVAR el stock: claves cs.compra.*, cs.contar.*, cs.perdida.* y cs.activar.*.
 * Paridad exacta es/en/pt (claves y placeholders {x}): la controla src/v2/i18n/parity.test.js.
 * Los prefijos por área los controla costsV3.test.js (dos áreas no pueden pisarse).
 *
 * Sin plurales en t(): lo que depende de un número tiene dos claves (….one / ….other) y la
 * pantalla elige (components/compra/texts.js → plural). Los números entran ya formateados.
 * Lo común (estados del insumo, unidades cortas, Guardar/Cancelar/Reintentar) está en cs.shell.*.
 */
const compra = {
  es: {
    // ── Cargar compra / Revisar precios
    "cs.compra.title": "Cargar compra",
    "cs.compra.titlePrecios": "Revisar precios",
    "cs.compra.titleDone": "Compra guardada",
    "cs.compra.titlePreciosDone": "Precios revisados",
    "cs.compra.supplier": "¿De quién?",
    "cs.compra.optional": "(opcional)",
    "cs.compra.supplierPh": "La Serenísima, el verdulero…",
    "cs.compra.preciosIntro.one": "El insumo que más pesa en tus platos. Poné lo que pagaste la última vez, o tocá \"Sigue igual\". Lo que no toques queda como estaba.",
    "cs.compra.preciosIntro.other": "Los {n} insumos que más pesan en tus platos. Poné lo que pagaste la última vez, o tocá \"Sigue igual\". Lo que no toques queda como estaba.",
    "cs.compra.preciosEmptyT": "Todavía no hay insumos en tus platos",
    "cs.compra.preciosEmpty": "Cuando costees un plato con receta, acá vas a ver los insumos que más pesan.",
    "cs.compra.rowsAria": "Insumos de la compra",
    "cs.compra.rowsPreciosAria": "Insumos para revisar",
    "cs.compra.qty": "Compraste",
    "cs.compra.qtyM": "¿Cuánto compraste?",
    "cs.compra.qtyPrecios": "Por",
    "cs.compra.total": "Pagaste en total",
    "cs.compra.totalM": "¿Cuánto pagaste en total?",
    "cs.compra.totalPrecios": "Pagaste",
    "cs.compra.unitAria": "Unidad de {name}",
    "cs.compra.per.kg": "el kg",
    "cs.compra.per.g": "el g",
    "cs.compra.per.lt": "el litro",
    "cs.compra.per.ml": "el ml",
    "cs.compra.per.u": "la unidad",
    "cs.compra.per.doc": "la docena",
    "cs.compra.word.kg": "kilo",
    "cs.compra.word.g": "gramo",
    "cs.compra.word.lt": "litro",
    "cs.compra.word.ml": "mililitro",
    "cs.compra.word.u": "unidad",
    "cs.compra.word.doc": "docena",
    "cs.compra.unitOpt.kg": "kg",
    "cs.compra.unitOpt.g": "g",
    "cs.compra.unitOpt.lt": "litros",
    "cs.compra.unitOpt.ml": "ml",
    "cs.compra.unitOpt.u": "unidades",
    "cs.compra.unitOpt.doc": "docenas",
    "cs.compra.before": "antes {price}",
    "cs.compra.up": "subió {pct}%",
    "cs.compra.down": "bajó {pct}%",
    "cs.compra.equal": "igual",
    "cs.compra.last": "La última vez: {qty} por {price}",
    "cs.compra.lastNoPrice": "La última vez: {qty}",
    "cs.compra.now": "Hoy figura a {price}",
    "cs.compra.noPrice": "Todavía no tiene precio",
    "cs.compra.noPriceShort": "falta precio",
    "cs.compra.brake": "Pasaría de {from} a {to} {per} ({ratio}).",
    "cs.compra.brakeQ": "¿Pusiste el total o el precio por {word}?",
    "cs.compra.brakeOk": "Sí, está bien así",
    "cs.compra.stock.add": "Sumar al stock",
    "cs.compra.stock.addFull": "Sumar al stock: hay {from} → {to}",
    "cs.compra.stock.addPlain": "Sumar {qty} al stock",
    "cs.compra.stock.first": "Nunca lo contaste: ¿cuánto tenés en total ahora?",
    "cs.compra.stock.oversold": "Se vendió de más: ¿cuánto tenés en total ahora?",
    "cs.compra.stock.stale": "Hace mucho que no lo contás: ¿cuánto tenés en total ahora?",
    "cs.compra.stock.start": "Empezar a controlar el stock",
    "cs.compra.stock.before": "Antes tenías",
    "cs.compra.stock.beforeAria": "Cuánto tenías de {name} antes de esta compra",
    "cs.compra.stock.startsWith": "Empieza con",
    "cs.compra.stock.loading": "Leyendo el stock…",
    "cs.compra.stock.error": "No pudimos leer el stock: esta compra actualiza sólo los precios.",
    "cs.compra.remove": "Quitar {name}",
    "cs.compra.new": "nuevo",
    "cs.compra.newUnit": "¿Cómo lo comprás?",
    "cs.compra.newUnit.kg": "Por kilo",
    "cs.compra.newUnit.lt": "Por litro",
    "cs.compra.newUnit.u": "Por unidad",
    "cs.compra.same": "Sigue igual",
    "cs.compra.sameDone": "Queda en {price}. Revisado hoy.",
    "cs.compra.sameDoneNoPrice": "Revisado hoy.",
    "cs.compra.add": "Agregar otro insumo de la factura…",
    "cs.compra.addFirst": "Buscá un insumo de la factura…",
    "cs.compra.addAria": "Buscar un insumo para agregar a la compra",
    "cs.compra.addResults": "Insumos encontrados",
    "cs.compra.create": "Crear \"{name}\"",
    "cs.compra.alreadyIn": "Ya está en la compra.",
    "cs.compra.emptyHint": "¿Qué llegó? Buscá el primer insumo de la factura.",
    "cs.compra.emptyHint.repo": "¿Qué llegó? Buscá el primer insumo de la factura o tocá uno de los que hay que reponer.",
    "cs.compra.emptyHint.top": "¿Qué llegó? Buscá el primer insumo de la factura o tocá uno de los que más usás.",
    "cs.compra.draft": "Seguís con la compra que dejaste sin guardar.",
    "cs.compra.draftPrecios": "Seguís con los precios que dejaste sin guardar.",
    "cs.compra.draftReset": "Empezar de cero",
    "cs.compra.sum.one": "1 insumo",
    "cs.compra.sum.other": "{n} insumos",
    "cs.compra.sumPrecios.one": "1 para guardar",
    "cs.compra.sumPrecios.other": "{n} para guardar",
    "cs.compra.sumNone": "Nada para guardar todavía",
    "cs.compra.save": "Guardar compra ({n})",
    "cs.compra.savePrecios": "Guardar precios ({n})",
    "cs.compra.saveNone": "Guardar compra",
    "cs.compra.savePreciosNone": "Guardar precios",
    "cs.compra.err.qtyMissing": "Falta cuánto compraste.",
    "cs.compra.err.qtyBad": "No entendimos la cantidad.",
    "cs.compra.err.qtyZero": "Tiene que ser más que 0.",
    "cs.compra.err.totalMissing": "Falta cuánto pagaste.",
    "cs.compra.err.totalBad": "No entendimos el precio.",
    "cs.compra.err.confirm": "Tildá \"Sí, está bien así\" para guardar.",
    "cs.compra.err.haveBad": "No entendimos ese número.",
    "cs.compra.err.haveNegative": "Tiene que ser 0 o más.",
    "cs.compra.err.beforeBad": "No entendimos ese número.",
    "cs.compra.err.beforeNegative": "Tiene que ser 0 o más.",
    "cs.compra.fixFirst": "Revisá lo marcado en rojo antes de guardar.",
    "cs.compra.tooLarge": "Es demasiado grande para guardar de una vez: partila en dos compras.",
    "cs.compra.done.saved": "Compra guardada.",
    "cs.compra.done.prices.one": "Actualizamos 1 precio.",
    "cs.compra.done.prices.other": "Actualizamos {n} precios.",
    "cs.compra.done.stock.one": "Sumamos 1 insumo al stock.",
    "cs.compra.done.stock.other": "Sumamos {n} insumos al stock.",
    "cs.compra.done.precios.one": "Revisaste 1 precio.",
    "cs.compra.done.precios.other": "Revisaste {n} precios.",
    "cs.compra.done.top": "{name} subió {pct}%.",
    "cs.compra.done.impact": "Estos platos ahora te dejan menos:",
    "cs.compra.done.impactHint": "Tocá uno para ver su costo o cambiarle el precio.",
    "cs.compra.done.noImpact": "Ningún plato cambió lo que te deja.",
    "cs.compra.done.another": "Cargar otra",
    "cs.compra.done.ok": "Listo",

    // ── Contar lo que hay
    "cs.contar.title": "Contar lo que hay",
    "cs.contar.progress": "{done} de {total} contados",
    "cs.contar.progressShort": "{done} de {total}",
    "cs.contar.introA": "Contá lo que ves.",
    "cs.contar.introB": "Lo que calculábamos aparece recién cuando cargás el número, así no te influye.",
    "cs.contar.stepInicial": "Paso 2 de 3 · Contá lo que hay",
    "cs.contar.introInicial": "Es tu número de arranque: desde acá, cada venta descuenta sola. Si querés, poné con cuánto te avisamos que se está terminando.",
    "cs.contar.reading": "Leyendo las ventas…",
    "cs.contar.loading": "Cargando la planilla…",
    "cs.contar.searchPh": "Buscar…",
    "cs.contar.searchAria": "Buscar insumo",
    "cs.contar.filtersAria": "Filtrar la planilla",
    "cs.contar.f.todos": "Todos",
    "cs.contar.f.faltan": "Faltan",
    "cs.contar.f.reponer": "Para reponer",
    "cs.contar.col.insumo": "Insumo",
    "cs.contar.col.contaste": "Contaste",
    "cs.contar.col.calc": "Calculábamos",
    "cs.contar.col.diff": "Diferencia",
    "cs.contar.col.plata": "En plata",
    "cs.contar.col.min": "Avisame con menos de",
    "cs.contar.inputAria": "Cuánto contaste de {name}",
    "cs.contar.minAria": "Avisame con menos de, para {name}",
    "cs.contar.inputPh": "¿Cuánto hay?",
    "cs.contar.calcHidden": "aparece cuando cargás",
    "cs.contar.why.first": "primer conteo",
    "cs.contar.why.stale": "no hay con qué comparar",
    "cs.contar.why.nosales": "sin ventas leídas",
    "cs.contar.why.oversold": "se vendió de más",
    "cs.contar.why.later": "ya se contó después",
    "cs.contar.why.late": "sin las ventas de ese rato",
    "cs.contar.whyLine.first": "Primer conteo: desde acá descuenta.",
    "cs.contar.whyLine.stale": "El último conteo es muy viejo: no hay con qué comparar.",
    "cs.contar.whyLine.nosales": "No pudimos leer las ventas: no hay con qué comparar.",
    "cs.contar.whyLine.oversold": "Se vendió de más: este número lo arregla.",
    "cs.contar.whyLine.later": "Ya se contó después por otro lado: este número no se guarda.",
    "cs.contar.whyLine.late": "No pudimos leer las ventas de ese rato: se guarda sin comparar.",
    "cs.contar.note.first": "nunca contado",
    "cs.contar.note.oversold": "se vendió de más",
    "cs.contar.note.stale": "hace mucho que no se cuenta",
    "cs.contar.note.retrack": "ya lo contaste antes: si no lo contás ahora, no se controla",
    "cs.contar.same": "Igual",
    "cs.contar.calcLine": "Calculábamos {qty}",
    "cs.contar.missingLine": "faltan {qty}",
    "cs.contar.extraLine": "sobran {qty}",
    "cs.contar.minHint": "Sin aviso, el mozo sólo ve \"Agotado\", nunca cuántos quedan.",
    "cs.contar.minHintSet": "Con menos de {qty}, el mozo ve cuántos quedan (por ejemplo, \"Quedan 3\").",
    "cs.contar.err.bad": "No entendimos ese número.",
    "cs.contar.err.negative": "Tiene que ser 0 o más.",
    "cs.contar.foot.rest": "Lo que no cargues queda como estaba.",
    "cs.contar.foot.missing": "Faltante hasta ahora",
    "cs.contar.foot.missingShort": "Faltó {plata}",
    "cs.contar.save": "Guardar {n}",
    "cs.contar.saveM.one": "Guardar 1 conteo",
    "cs.contar.saveM.other": "Guardar {n} conteos",
    "cs.contar.fixFirst": "Revisá los números marcados en rojo.",
    "cs.contar.leave.one": "Tenés 1 número sin guardar.",
    "cs.contar.leave.other": "Tenés {n} números sin guardar.",
    "cs.contar.leaveGo": "Salir sin guardar",
    "cs.contar.draft.one": "Recuperamos 1 número que cargaste y no guardaste.",
    "cs.contar.draft.other": "Recuperamos {n} números que cargaste y no guardaste.",
    "cs.contar.draftReset": "Empezar de cero",
    "cs.contar.draftHidden.one": "Tenés 1 número de otro conteo sin guardar.",
    "cs.contar.draftHidden.other": "Tenés {n} números de otro conteo sin guardar.",
    "cs.contar.salesError": "No pudimos leer las ventas: lo que calculábamos puede estar inflado. Lo que cuentes se guarda igual.",
    "cs.contar.stockError": "No pudimos leer el stock. Revisá la conexión y probá de nuevo.",
    "cs.contar.emptyNone.title": "Todavía no controlás ningún insumo",
    "cs.contar.emptyNone.body": "Elegí qué controlar en Insumos y después contalo acá.",
    "cs.contar.emptyNone.go": "Ir a Insumos",
    "cs.contar.emptyFilter": "Nada para mostrar con este filtro.",
    "cs.contar.emptySearch": "Ningún insumo con ese nombre.",
    "cs.contar.onlyIds": "Contando {n} de {total}.",
    "cs.contar.allLink": "Contar todos",
    "cs.contar.partial.one": "Se guardó 1; tocá Reintentar para el resto.",
    "cs.contar.partial.other": "Se guardaron {n}; tocá Reintentar para el resto.",
    "cs.contar.done.saved.one": "Guardamos 1 conteo.",
    "cs.contar.done.saved.other": "Guardamos {n} conteos.",
    "cs.contar.done.mins.one": "Guardamos 1 aviso.",
    "cs.contar.done.mins.other": "Guardamos {n} avisos.",
    "cs.contar.done.missing": "Faltaron {plata} desde el último conteo (lo que se tiró sin anotar o se usó de más).",
    "cs.contar.done.extra": "Sobraron {plata} respecto de lo que calculábamos.",
    "cs.contar.done.same": "Todo dio igual que lo que calculábamos.",
    "cs.contar.done.worstA": "El que más:",
    "cs.contar.done.replace": "El conteo reemplaza lo que el sistema calculaba. Desde ahora, cada venta descuenta de este número.",
    "cs.contar.done.later.one": "1 número no se guardó: ese insumo ya se había contado después.",
    "cs.contar.done.later.other": "{n} números no se guardaron: esos insumos ya se habían contado después.",
    "cs.contar.done.ok": "Listo",
    "cs.contar.inicial.done": "Listo: cada venta descuenta.",
    "cs.contar.step3.title": "Último paso: ¿qué pasa cuando algo se agota?",
    "cs.contar.step3.switch": "No dejar vender lo agotado",
    "cs.contar.step3.on": "El mozo no puede cargar un plato agotado.",
    "cs.contar.step3.off": "El mozo ve \"Agotado\", pero lo puede cargar igual.",
    "cs.contar.step3.later": "Lo podés cambiar cuando quieras en Ajustes.",
    "cs.contar.step3.saved": "Guardado",

    // ── Anotar pérdida
    "cs.perdida.title": "Anotar pérdida",
    "cs.perdida.pick.intro": "¿Qué se perdió?",
    "cs.perdida.pick.search": "Buscar insumo…",
    "cs.perdida.pick.emptyT": "No controlás ningún insumo",
    "cs.perdida.pick.empty": "Las pérdidas se anotan en los insumos que controlás. Elegí cuáles en Insumos.",
    "cs.perdida.pick.none": "Ningún insumo con ese nombre.",
    "cs.perdida.pick.notTracked": "{name} no se controla: elegí uno de los que sí.",
    "cs.perdida.hay": "Hay {qty}",
    "cs.perdida.hayOversold": "Se vendió de más",
    "cs.perdida.haySinContar": "Sin contar",
    "cs.perdida.change": "Cambiar",
    "cs.perdida.qty": "¿Cuánto se perdió?",
    "cs.perdida.unitAria": "Unidad",
    "cs.perdida.why": "¿Por qué?",
    "cs.perdida.reason.vencio": "Se venció",
    "cs.perdida.reason.quemo": "Se quemó",
    "cs.perdida.reason.cayo": "Se cayó",
    "cs.perdida.reason.otro": "Otro",
    "cs.perdida.otherPh": "Contanos qué pasó (opcional)",
    "cs.perdida.otherAria": "Qué pasó",
    "cs.perdida.moneyA": "Son",
    "cs.perdida.moneyB": "que se fueron.",
    "cs.perdida.noPrice": "No tiene precio: no sabemos cuánta plata es.",
    "cs.perdida.more": "Es más de lo que hay ({qty}).",
    "cs.perdida.err.bad": "No entendimos ese número.",
    "cs.perdida.err.zero": "Tiene que ser más que 0.",
    "cs.perdida.save": "Guardar pérdida",
    "cs.perdida.saved": "Anotaste {qty} de {name} ({plata}).",
    "cs.perdida.savedNoPrice": "Anotaste {qty} de {name}.",
    "cs.perdida.noStock": "Las pérdidas se anotan con el stock de Gestión del local.",

    // ── Activar el stock (3 pasos)
    "cs.activar.title": "Controlá tu stock en 3 pasos",
    "cs.activar.stepsAria": "Pasos para controlar el stock",
    "cs.activar.step1": "Qué controlar",
    "cs.activar.step2": "Contar lo que hay",
    "cs.activar.step3": "No vender lo agotado",
    "cs.activar.sub": "Te marcamos los que usan tus platos con receta, primero los que más plata mueven.",
    "cs.activar.noRecipes": "Todavía ningún plato tiene receta, y sin receta la venta no descuenta. Costeá tus platos y volvé.",
    "cs.activar.noIngredients": "Para controlar el stock primero necesitás insumos: cargá una compra o costeá un plato.",
    "cs.activar.loadCompra": "Cargar compra",
    "cs.activar.groupAria": "Insumos para controlar",
    "cs.activar.pick.one": "{name} · 1 plato",
    "cs.activar.pick.other": "{name} · {n} platos",
    "cs.activar.pick.none": "{name} · ningún plato",
    "cs.activar.showMore": "Ver {n} más",
    "cs.activar.unused.one": "1 insumo que no está en ningún plato",
    "cs.activar.unused.other": "{n} insumos que no están en ningún plato",
    "cs.activar.unusedHint": "Los que no están en ningún plato sólo bajan con lo que cargues a mano.",
    "cs.activar.drinks.one": "1 bebida de tu carta no tiene costo. Costeala \"tal cual\" para que descuente.",
    "cs.activar.drinks.other": "{n} bebidas de tu carta no tienen costo. Costealas \"tal cual\" para que descuenten.",
    "cs.activar.drinksSee": "Ver cuáles",
    "cs.activar.count.one": "1 elegido",
    "cs.activar.count.other": "{n} elegidos",
    "cs.activar.goNone": "Elegí al menos uno",
    "cs.activar.go": "Seguir con {n}",
  },

  en: {
    "cs.compra.title": "Log a purchase",
    "cs.compra.titlePrecios": "Review prices",
    "cs.compra.titleDone": "Purchase saved",
    "cs.compra.titlePreciosDone": "Prices reviewed",
    "cs.compra.supplier": "From whom?",
    "cs.compra.optional": "(optional)",
    "cs.compra.supplierPh": "The dairy, the greengrocer…",
    "cs.compra.preciosIntro.one": "The supply that weighs most on your dishes. Enter what you paid last time, or tap \"Still the same\". Anything you don't touch stays as it was.",
    "cs.compra.preciosIntro.other": "The {n} supplies that weigh most on your dishes. Enter what you paid last time, or tap \"Still the same\". Anything you don't touch stays as it was.",
    "cs.compra.preciosEmptyT": "No supplies in your dishes yet",
    "cs.compra.preciosEmpty": "Once you cost a dish with a recipe, the supplies that weigh most will show up here.",
    "cs.compra.rowsAria": "Supplies in this purchase",
    "cs.compra.rowsPreciosAria": "Supplies to review",
    "cs.compra.qty": "You bought",
    "cs.compra.qtyM": "How much did you buy?",
    "cs.compra.qtyPrecios": "For",
    "cs.compra.total": "You paid in total",
    "cs.compra.totalM": "How much did you pay in total?",
    "cs.compra.totalPrecios": "You paid",
    "cs.compra.unitAria": "Unit for {name}",
    "cs.compra.per.kg": "per kg",
    "cs.compra.per.g": "per g",
    "cs.compra.per.lt": "per liter",
    "cs.compra.per.ml": "per ml",
    "cs.compra.per.u": "each",
    "cs.compra.per.doc": "per dozen",
    "cs.compra.word.kg": "kilo",
    "cs.compra.word.g": "gram",
    "cs.compra.word.lt": "liter",
    "cs.compra.word.ml": "milliliter",
    "cs.compra.word.u": "unit",
    "cs.compra.word.doc": "dozen",
    "cs.compra.unitOpt.kg": "kg",
    "cs.compra.unitOpt.g": "g",
    "cs.compra.unitOpt.lt": "liters",
    "cs.compra.unitOpt.ml": "ml",
    "cs.compra.unitOpt.u": "units",
    "cs.compra.unitOpt.doc": "dozens",
    "cs.compra.before": "before {price}",
    "cs.compra.up": "up {pct}%",
    "cs.compra.down": "down {pct}%",
    "cs.compra.equal": "same",
    "cs.compra.last": "Last time: {qty} for {price}",
    "cs.compra.lastNoPrice": "Last time: {qty}",
    "cs.compra.now": "Currently {price}",
    "cs.compra.noPrice": "No price yet",
    "cs.compra.noPriceShort": "no price",
    "cs.compra.brake": "It would go from {from} to {to} {per} ({ratio}).",
    "cs.compra.brakeQ": "Did you enter the total or the price per {word}?",
    "cs.compra.brakeOk": "Yes, that's right",
    "cs.compra.stock.add": "Add to stock",
    "cs.compra.stock.addFull": "Add to stock: {from} on hand → {to}",
    "cs.compra.stock.addPlain": "Add {qty} to stock",
    "cs.compra.stock.first": "You've never counted it: how much do you have in total now?",
    "cs.compra.stock.oversold": "More was sold than you had: how much do you have in total now?",
    "cs.compra.stock.stale": "It hasn't been counted in a long time: how much do you have in total now?",
    "cs.compra.stock.start": "Start tracking its stock",
    "cs.compra.stock.before": "You had",
    "cs.compra.stock.beforeAria": "How much {name} you had before this purchase",
    "cs.compra.stock.startsWith": "Starts at",
    "cs.compra.stock.loading": "Reading stock…",
    "cs.compra.stock.error": "We couldn't read your stock: this purchase only updates prices.",
    "cs.compra.remove": "Remove {name}",
    "cs.compra.new": "new",
    "cs.compra.newUnit": "How do you buy it?",
    "cs.compra.newUnit.kg": "By the kilo",
    "cs.compra.newUnit.lt": "By the liter",
    "cs.compra.newUnit.u": "By the unit",
    "cs.compra.same": "Still the same",
    "cs.compra.sameDone": "Stays at {price}. Reviewed today.",
    "cs.compra.sameDoneNoPrice": "Reviewed today.",
    "cs.compra.add": "Add another supply from the invoice…",
    "cs.compra.addFirst": "Search for a supply on the invoice…",
    "cs.compra.addAria": "Search for a supply to add to the purchase",
    "cs.compra.addResults": "Supplies found",
    "cs.compra.create": "Create \"{name}\"",
    "cs.compra.alreadyIn": "It's already in the purchase.",
    "cs.compra.emptyHint": "What arrived? Search for the first supply on the invoice.",
    "cs.compra.emptyHint.repo": "What arrived? Search for the first supply on the invoice, or tap one that needs restocking.",
    "cs.compra.emptyHint.top": "What arrived? Search for the first supply on the invoice, or tap one you use most.",
    "cs.compra.draft": "You're picking up the purchase you left unsaved.",
    "cs.compra.draftPrecios": "You're picking up the prices you left unsaved.",
    "cs.compra.draftReset": "Start over",
    "cs.compra.sum.one": "1 supply",
    "cs.compra.sum.other": "{n} supplies",
    "cs.compra.sumPrecios.one": "1 to save",
    "cs.compra.sumPrecios.other": "{n} to save",
    "cs.compra.sumNone": "Nothing to save yet",
    "cs.compra.save": "Save purchase ({n})",
    "cs.compra.savePrecios": "Save prices ({n})",
    "cs.compra.saveNone": "Save purchase",
    "cs.compra.savePreciosNone": "Save prices",
    "cs.compra.err.qtyMissing": "Enter how much you bought.",
    "cs.compra.err.qtyBad": "We couldn't read the quantity.",
    "cs.compra.err.qtyZero": "It has to be more than 0.",
    "cs.compra.err.totalMissing": "Enter how much you paid.",
    "cs.compra.err.totalBad": "We couldn't read the price.",
    "cs.compra.err.confirm": "Tick \"Yes, that's right\" to save.",
    "cs.compra.err.haveBad": "We couldn't read that number.",
    "cs.compra.err.haveNegative": "It has to be 0 or more.",
    "cs.compra.err.beforeBad": "We couldn't read that number.",
    "cs.compra.err.beforeNegative": "It has to be 0 or more.",
    "cs.compra.fixFirst": "Check what's marked in red before saving.",
    "cs.compra.tooLarge": "It's too big to save at once: split it into two purchases.",
    "cs.compra.done.saved": "Purchase saved.",
    "cs.compra.done.prices.one": "We updated 1 price.",
    "cs.compra.done.prices.other": "We updated {n} prices.",
    "cs.compra.done.stock.one": "We added 1 supply to stock.",
    "cs.compra.done.stock.other": "We added {n} supplies to stock.",
    "cs.compra.done.precios.one": "You reviewed 1 price.",
    "cs.compra.done.precios.other": "You reviewed {n} prices.",
    "cs.compra.done.top": "{name} went up {pct}%.",
    "cs.compra.done.impact": "These dishes now leave you less:",
    "cs.compra.done.impactHint": "Tap one to see its cost or change its price.",
    "cs.compra.done.noImpact": "No dish changed what it leaves you.",
    "cs.compra.done.another": "Log another",
    "cs.compra.done.ok": "Done",

    "cs.contar.title": "Count what you have",
    "cs.contar.progress": "{done} of {total} counted",
    "cs.contar.progressShort": "{done} of {total}",
    "cs.contar.introA": "Count what you see.",
    "cs.contar.introB": "What we calculated only shows up once you enter the number, so it doesn't sway you.",
    "cs.contar.stepInicial": "Step 2 of 3 · Count what you have",
    "cs.contar.introInicial": "This is your starting number: from here on, every sale deducts on its own. If you want, set when we should warn you it's running low.",
    "cs.contar.reading": "Reading sales…",
    "cs.contar.loading": "Loading the sheet…",
    "cs.contar.searchPh": "Search…",
    "cs.contar.searchAria": "Search supply",
    "cs.contar.filtersAria": "Filter the sheet",
    "cs.contar.f.todos": "All",
    "cs.contar.f.faltan": "Missing",
    "cs.contar.f.reponer": "To restock",
    "cs.contar.col.insumo": "Supply",
    "cs.contar.col.contaste": "You counted",
    "cs.contar.col.calc": "We calculated",
    "cs.contar.col.diff": "Difference",
    "cs.contar.col.plata": "In money",
    "cs.contar.col.min": "Warn me below",
    "cs.contar.inputAria": "How much {name} you counted",
    "cs.contar.minAria": "Warn me below, for {name}",
    "cs.contar.inputPh": "How much is there?",
    "cs.contar.calcHidden": "shows once you enter it",
    "cs.contar.why.first": "first count",
    "cs.contar.why.stale": "nothing to compare",
    "cs.contar.why.nosales": "no sales read",
    "cs.contar.why.oversold": "more sold than you had",
    "cs.contar.why.later": "counted later",
    "cs.contar.why.late": "no sales for that time",
    "cs.contar.whyLine.first": "First count: it deducts from here.",
    "cs.contar.whyLine.stale": "The last count is too old: nothing to compare.",
    "cs.contar.whyLine.nosales": "We couldn't read sales: nothing to compare.",
    "cs.contar.whyLine.oversold": "More was sold than you had: this number fixes it.",
    "cs.contar.whyLine.later": "It was counted later somewhere else: this number won't be saved.",
    "cs.contar.whyLine.late": "We couldn't read the sales for that time: it's saved without comparing.",
    "cs.contar.note.first": "never counted",
    "cs.contar.note.oversold": "more sold than you had",
    "cs.contar.note.stale": "not counted in a long time",
    "cs.contar.note.retrack": "you counted it before: if you don't count it now, it won't be tracked",
    "cs.contar.same": "Same",
    "cs.contar.calcLine": "We calculated {qty}",
    "cs.contar.missingLine": "{qty} missing",
    "cs.contar.extraLine": "{qty} extra",
    "cs.contar.minHint": "With no warning, the waiter only sees \"Sold out\", never how many are left.",
    "cs.contar.minHintSet": "Below {qty}, the waiter sees how many are left (for example, \"3 left\").",
    "cs.contar.err.bad": "We couldn't read that number.",
    "cs.contar.err.negative": "It has to be 0 or more.",
    "cs.contar.foot.rest": "Anything you don't enter stays as it was.",
    "cs.contar.foot.missing": "Missing so far",
    "cs.contar.foot.missingShort": "{plata} missing",
    "cs.contar.save": "Save {n}",
    "cs.contar.saveM.one": "Save 1 count",
    "cs.contar.saveM.other": "Save {n} counts",
    "cs.contar.fixFirst": "Check the numbers marked in red.",
    "cs.contar.leave.one": "You have 1 unsaved number.",
    "cs.contar.leave.other": "You have {n} unsaved numbers.",
    "cs.contar.leaveGo": "Leave without saving",
    "cs.contar.draft.one": "We recovered 1 number you entered and didn't save.",
    "cs.contar.draft.other": "We recovered {n} numbers you entered and didn't save.",
    "cs.contar.draftReset": "Start over",
    "cs.contar.draftHidden.one": "You have 1 unsaved number from another count.",
    "cs.contar.draftHidden.other": "You have {n} unsaved numbers from another count.",
    "cs.contar.salesError": "We couldn't read sales: what we calculated may be too high. What you count is saved anyway.",
    "cs.contar.stockError": "We couldn't read your stock. Check your connection and try again.",
    "cs.contar.emptyNone.title": "You're not tracking any supply yet",
    "cs.contar.emptyNone.body": "Choose what to track in Supplies, then count it here.",
    "cs.contar.emptyNone.go": "Go to Supplies",
    "cs.contar.emptyFilter": "Nothing to show with this filter.",
    "cs.contar.emptySearch": "No supply with that name.",
    "cs.contar.onlyIds": "Counting {n} of {total}.",
    "cs.contar.allLink": "Count all",
    "cs.contar.partial.one": "1 was saved; tap Try again for the rest.",
    "cs.contar.partial.other": "{n} were saved; tap Try again for the rest.",
    "cs.contar.done.saved.one": "We saved 1 count.",
    "cs.contar.done.saved.other": "We saved {n} counts.",
    "cs.contar.done.mins.one": "We saved 1 warning.",
    "cs.contar.done.mins.other": "We saved {n} warnings.",
    "cs.contar.done.missing": "{plata} went missing since the last count (thrown out without logging, or used more than planned).",
    "cs.contar.done.extra": "{plata} more than we calculated.",
    "cs.contar.done.same": "Everything matched what we calculated.",
    "cs.contar.done.worstA": "The biggest one:",
    "cs.contar.done.replace": "The count replaces what the system calculated. From now on, every sale deducts from this number.",
    "cs.contar.done.later.one": "1 number wasn't saved: that supply had been counted later.",
    "cs.contar.done.later.other": "{n} numbers weren't saved: those supplies had been counted later.",
    "cs.contar.done.ok": "Done",
    "cs.contar.inicial.done": "Done: every sale deducts.",
    "cs.contar.step3.title": "Last step: what happens when something sells out?",
    "cs.contar.step3.switch": "Don't allow selling what's sold out",
    "cs.contar.step3.on": "The waiter can't add a dish that's sold out.",
    "cs.contar.step3.off": "The waiter sees \"Sold out\", but can still add it.",
    "cs.contar.step3.later": "You can change this anytime in Settings.",
    "cs.contar.step3.saved": "Saved",

    "cs.perdida.title": "Log a loss",
    "cs.perdida.pick.intro": "What was lost?",
    "cs.perdida.pick.search": "Search supply…",
    "cs.perdida.pick.emptyT": "You're not tracking any supply",
    "cs.perdida.pick.empty": "Losses are logged on the supplies you track. Choose them in Supplies.",
    "cs.perdida.pick.none": "No supply with that name.",
    "cs.perdida.pick.notTracked": "{name} isn't tracked: choose one that is.",
    "cs.perdida.hay": "{qty} on hand",
    "cs.perdida.hayOversold": "More sold than you had",
    "cs.perdida.haySinContar": "Not counted",
    "cs.perdida.change": "Change",
    "cs.perdida.qty": "How much was lost?",
    "cs.perdida.unitAria": "Unit",
    "cs.perdida.why": "Why?",
    "cs.perdida.reason.vencio": "It expired",
    "cs.perdida.reason.quemo": "It burned",
    "cs.perdida.reason.cayo": "It fell",
    "cs.perdida.reason.otro": "Other",
    "cs.perdida.otherPh": "Tell us what happened (optional)",
    "cs.perdida.otherAria": "What happened",
    "cs.perdida.moneyA": "That's",
    "cs.perdida.moneyB": "gone.",
    "cs.perdida.noPrice": "It has no price: we don't know how much money it is.",
    "cs.perdida.more": "That's more than you have ({qty}).",
    "cs.perdida.err.bad": "We couldn't read that number.",
    "cs.perdida.err.zero": "It has to be more than 0.",
    "cs.perdida.save": "Save loss",
    "cs.perdida.saved": "You logged {qty} of {name} ({plata}).",
    "cs.perdida.savedNoPrice": "You logged {qty} of {name}.",
    "cs.perdida.noStock": "Losses are logged with the stock in the Management pack.",

    "cs.activar.title": "Track your stock in 3 steps",
    "cs.activar.stepsAria": "Steps to track stock",
    "cs.activar.step1": "What to track",
    "cs.activar.step2": "Count what you have",
    "cs.activar.step3": "Don't sell what's sold out",
    "cs.activar.sub": "We ticked the ones your dishes with a recipe use, starting with the ones that move the most money.",
    "cs.activar.noRecipes": "No dish has a recipe yet, and without a recipe sales don't deduct. Cost your dishes and come back.",
    "cs.activar.noIngredients": "To track stock you first need supplies: log a purchase or cost a dish.",
    "cs.activar.loadCompra": "Log a purchase",
    "cs.activar.groupAria": "Supplies to track",
    "cs.activar.pick.one": "{name} · 1 dish",
    "cs.activar.pick.other": "{name} · {n} dishes",
    "cs.activar.pick.none": "{name} · no dish",
    "cs.activar.showMore": "Show {n} more",
    "cs.activar.unused.one": "1 supply that isn't in any dish",
    "cs.activar.unused.other": "{n} supplies that aren't in any dish",
    "cs.activar.unusedHint": "Supplies that aren't in any dish only go down with what you enter by hand.",
    "cs.activar.drinks.one": "1 drink on your menu has no cost. Cost it \"as is\" so it deducts.",
    "cs.activar.drinks.other": "{n} drinks on your menu have no cost. Cost them \"as is\" so they deduct.",
    "cs.activar.drinksSee": "See which",
    "cs.activar.count.one": "1 selected",
    "cs.activar.count.other": "{n} selected",
    "cs.activar.goNone": "Pick at least one",
    "cs.activar.go": "Continue with {n}",
  },

  pt: {
    "cs.compra.title": "Registrar compra",
    "cs.compra.titlePrecios": "Revisar preços",
    "cs.compra.titleDone": "Compra salva",
    "cs.compra.titlePreciosDone": "Preços revisados",
    "cs.compra.supplier": "De quem?",
    "cs.compra.optional": "(opcional)",
    "cs.compra.supplierPh": "O laticínio, o verdureiro…",
    "cs.compra.preciosIntro.one": "O insumo que mais pesa nos seus pratos. Coloque o que você pagou da última vez, ou toque em \"Continua igual\". O que você não mexer fica como estava.",
    "cs.compra.preciosIntro.other": "Os {n} insumos que mais pesam nos seus pratos. Coloque o que você pagou da última vez, ou toque em \"Continua igual\". O que você não mexer fica como estava.",
    "cs.compra.preciosEmptyT": "Ainda não há insumos nos seus pratos",
    "cs.compra.preciosEmpty": "Quando você custear um prato com receita, aqui vão aparecer os insumos que mais pesam.",
    "cs.compra.rowsAria": "Insumos da compra",
    "cs.compra.rowsPreciosAria": "Insumos para revisar",
    "cs.compra.qty": "Comprou",
    "cs.compra.qtyM": "Quanto você comprou?",
    "cs.compra.qtyPrecios": "Por",
    "cs.compra.total": "Pagou no total",
    "cs.compra.totalM": "Quanto você pagou no total?",
    "cs.compra.totalPrecios": "Pagou",
    "cs.compra.unitAria": "Unidade de {name}",
    "cs.compra.per.kg": "o kg",
    "cs.compra.per.g": "o g",
    "cs.compra.per.lt": "o litro",
    "cs.compra.per.ml": "o ml",
    "cs.compra.per.u": "a unidade",
    "cs.compra.per.doc": "a dúzia",
    "cs.compra.word.kg": "quilo",
    "cs.compra.word.g": "grama",
    "cs.compra.word.lt": "litro",
    "cs.compra.word.ml": "mililitro",
    "cs.compra.word.u": "unidade",
    "cs.compra.word.doc": "dúzia",
    "cs.compra.unitOpt.kg": "kg",
    "cs.compra.unitOpt.g": "g",
    "cs.compra.unitOpt.lt": "litros",
    "cs.compra.unitOpt.ml": "ml",
    "cs.compra.unitOpt.u": "unidades",
    "cs.compra.unitOpt.doc": "dúzias",
    "cs.compra.before": "antes {price}",
    "cs.compra.up": "subiu {pct}%",
    "cs.compra.down": "caiu {pct}%",
    "cs.compra.equal": "igual",
    "cs.compra.last": "Da última vez: {qty} por {price}",
    "cs.compra.lastNoPrice": "Da última vez: {qty}",
    "cs.compra.now": "Hoje está a {price}",
    "cs.compra.noPrice": "Ainda sem preço",
    "cs.compra.noPriceShort": "falta preço",
    "cs.compra.brake": "Passaria de {from} para {to} {per} ({ratio}).",
    "cs.compra.brakeQ": "Você colocou o total ou o preço por {word}?",
    "cs.compra.brakeOk": "Sim, está certo",
    "cs.compra.stock.add": "Somar ao estoque",
    "cs.compra.stock.addFull": "Somar ao estoque: tem {from} → {to}",
    "cs.compra.stock.addPlain": "Somar {qty} ao estoque",
    "cs.compra.stock.first": "Você nunca contou: quanto tem no total agora?",
    "cs.compra.stock.oversold": "Vendeu-se a mais: quanto tem no total agora?",
    "cs.compra.stock.stale": "Faz tempo que você não conta: quanto tem no total agora?",
    "cs.compra.stock.start": "Começar a controlar o estoque",
    "cs.compra.stock.before": "Antes tinha",
    "cs.compra.stock.beforeAria": "Quanto você tinha de {name} antes desta compra",
    "cs.compra.stock.startsWith": "Começa com",
    "cs.compra.stock.loading": "Lendo o estoque…",
    "cs.compra.stock.error": "Não conseguimos ler o estoque: esta compra atualiza só os preços.",
    "cs.compra.remove": "Tirar {name}",
    "cs.compra.new": "novo",
    "cs.compra.newUnit": "Como você compra?",
    "cs.compra.newUnit.kg": "Por quilo",
    "cs.compra.newUnit.lt": "Por litro",
    "cs.compra.newUnit.u": "Por unidade",
    "cs.compra.same": "Continua igual",
    "cs.compra.sameDone": "Fica em {price}. Revisado hoje.",
    "cs.compra.sameDoneNoPrice": "Revisado hoje.",
    "cs.compra.add": "Adicionar outro insumo da nota…",
    "cs.compra.addFirst": "Busque um insumo da nota…",
    "cs.compra.addAria": "Buscar um insumo para adicionar à compra",
    "cs.compra.addResults": "Insumos encontrados",
    "cs.compra.create": "Criar \"{name}\"",
    "cs.compra.alreadyIn": "Já está na compra.",
    "cs.compra.emptyHint": "O que chegou? Busque o primeiro insumo da nota.",
    "cs.compra.emptyHint.repo": "O que chegou? Busque o primeiro insumo da nota ou toque em um dos que precisam repor.",
    "cs.compra.emptyHint.top": "O que chegou? Busque o primeiro insumo da nota ou toque em um dos que você mais usa.",
    "cs.compra.draft": "Você continua a compra que deixou sem salvar.",
    "cs.compra.draftPrecios": "Você continua os preços que deixou sem salvar.",
    "cs.compra.draftReset": "Começar do zero",
    "cs.compra.sum.one": "1 insumo",
    "cs.compra.sum.other": "{n} insumos",
    "cs.compra.sumPrecios.one": "1 para salvar",
    "cs.compra.sumPrecios.other": "{n} para salvar",
    "cs.compra.sumNone": "Nada para salvar ainda",
    "cs.compra.save": "Salvar compra ({n})",
    "cs.compra.savePrecios": "Salvar preços ({n})",
    "cs.compra.saveNone": "Salvar compra",
    "cs.compra.savePreciosNone": "Salvar preços",
    "cs.compra.err.qtyMissing": "Falta quanto você comprou.",
    "cs.compra.err.qtyBad": "Não entendemos a quantidade.",
    "cs.compra.err.qtyZero": "Tem que ser mais que 0.",
    "cs.compra.err.totalMissing": "Falta quanto você pagou.",
    "cs.compra.err.totalBad": "Não entendemos o preço.",
    "cs.compra.err.confirm": "Marque \"Sim, está certo\" para salvar.",
    "cs.compra.err.haveBad": "Não entendemos esse número.",
    "cs.compra.err.haveNegative": "Tem que ser 0 ou mais.",
    "cs.compra.err.beforeBad": "Não entendemos esse número.",
    "cs.compra.err.beforeNegative": "Tem que ser 0 ou mais.",
    "cs.compra.fixFirst": "Revise o que está em vermelho antes de salvar.",
    "cs.compra.tooLarge": "É grande demais para salvar de uma vez: divida em duas compras.",
    "cs.compra.done.saved": "Compra salva.",
    "cs.compra.done.prices.one": "Atualizamos 1 preço.",
    "cs.compra.done.prices.other": "Atualizamos {n} preços.",
    "cs.compra.done.stock.one": "Somamos 1 insumo ao estoque.",
    "cs.compra.done.stock.other": "Somamos {n} insumos ao estoque.",
    "cs.compra.done.precios.one": "Você revisou 1 preço.",
    "cs.compra.done.precios.other": "Você revisou {n} preços.",
    "cs.compra.done.top": "{name} subiu {pct}%.",
    "cs.compra.done.impact": "Estes pratos agora deixam menos:",
    "cs.compra.done.impactHint": "Toque em um para ver o custo ou mudar o preço.",
    "cs.compra.done.noImpact": "Nenhum prato mudou o que deixa.",
    "cs.compra.done.another": "Registrar outra",
    "cs.compra.done.ok": "Pronto",

    "cs.contar.title": "Contar o que tem",
    "cs.contar.progress": "{done} de {total} contados",
    "cs.contar.progressShort": "{done} de {total}",
    "cs.contar.introA": "Conte o que você vê.",
    "cs.contar.introB": "O que calculávamos só aparece quando você coloca o número, assim não te influencia.",
    "cs.contar.stepInicial": "Passo 2 de 3 · Conte o que tem",
    "cs.contar.introInicial": "É o seu número de partida: daqui em diante, cada venda desconta sozinha. Se quiser, diga com quanto avisamos que está acabando.",
    "cs.contar.reading": "Lendo as vendas…",
    "cs.contar.loading": "Carregando a planilha…",
    "cs.contar.searchPh": "Buscar…",
    "cs.contar.searchAria": "Buscar insumo",
    "cs.contar.filtersAria": "Filtrar a planilha",
    "cs.contar.f.todos": "Todos",
    "cs.contar.f.faltan": "Faltam",
    "cs.contar.f.reponer": "Para repor",
    "cs.contar.col.insumo": "Insumo",
    "cs.contar.col.contaste": "Contou",
    "cs.contar.col.calc": "Calculávamos",
    "cs.contar.col.diff": "Diferença",
    "cs.contar.col.plata": "Em dinheiro",
    "cs.contar.col.min": "Avise com menos de",
    "cs.contar.inputAria": "Quanto você contou de {name}",
    "cs.contar.minAria": "Avise com menos de, para {name}",
    "cs.contar.inputPh": "Quanto tem?",
    "cs.contar.calcHidden": "aparece quando você coloca",
    "cs.contar.why.first": "primeira contagem",
    "cs.contar.why.stale": "sem com o que comparar",
    "cs.contar.why.nosales": "sem vendas lidas",
    "cs.contar.why.oversold": "vendeu-se a mais",
    "cs.contar.why.later": "contado depois",
    "cs.contar.why.late": "sem as vendas desse período",
    "cs.contar.whyLine.first": "Primeira contagem: daqui em diante desconta.",
    "cs.contar.whyLine.stale": "A última contagem é muito antiga: não há com o que comparar.",
    "cs.contar.whyLine.nosales": "Não conseguimos ler as vendas: não há com o que comparar.",
    "cs.contar.whyLine.oversold": "Vendeu-se a mais: este número corrige.",
    "cs.contar.whyLine.later": "Já foi contado depois por outro lado: este número não será salvo.",
    "cs.contar.whyLine.late": "Não conseguimos ler as vendas desse período: salva sem comparar.",
    "cs.contar.note.first": "nunca contado",
    "cs.contar.note.oversold": "vendeu-se a mais",
    "cs.contar.note.stale": "faz tempo que não é contado",
    "cs.contar.note.retrack": "você já contou antes: se não contar agora, não será controlado",
    "cs.contar.same": "Igual",
    "cs.contar.calcLine": "Calculávamos {qty}",
    "cs.contar.missingLine": "faltam {qty}",
    "cs.contar.extraLine": "sobram {qty}",
    "cs.contar.minHint": "Sem aviso, o garçom só vê \"Esgotado\", nunca quantos restam.",
    "cs.contar.minHintSet": "Com menos de {qty}, o garçom vê quantos restam (por exemplo, \"Restam 3\").",
    "cs.contar.err.bad": "Não entendemos esse número.",
    "cs.contar.err.negative": "Tem que ser 0 ou mais.",
    "cs.contar.foot.rest": "O que você não preencher fica como estava.",
    "cs.contar.foot.missing": "Faltante até agora",
    "cs.contar.foot.missingShort": "Faltou {plata}",
    "cs.contar.save": "Salvar {n}",
    "cs.contar.saveM.one": "Salvar 1 contagem",
    "cs.contar.saveM.other": "Salvar {n} contagens",
    "cs.contar.fixFirst": "Revise os números em vermelho.",
    "cs.contar.leave.one": "Você tem 1 número sem salvar.",
    "cs.contar.leave.other": "Você tem {n} números sem salvar.",
    "cs.contar.leaveGo": "Sair sem salvar",
    "cs.contar.draft.one": "Recuperamos 1 número que você colocou e não salvou.",
    "cs.contar.draft.other": "Recuperamos {n} números que você colocou e não salvou.",
    "cs.contar.draftReset": "Começar do zero",
    "cs.contar.draftHidden.one": "Você tem 1 número de outra contagem sem salvar.",
    "cs.contar.draftHidden.other": "Você tem {n} números de outra contagem sem salvar.",
    "cs.contar.salesError": "Não conseguimos ler as vendas: o que calculávamos pode estar inflado. O que você contar é salvo mesmo assim.",
    "cs.contar.stockError": "Não conseguimos ler o estoque. Confira a conexão e tente de novo.",
    "cs.contar.emptyNone.title": "Você ainda não controla nenhum insumo",
    "cs.contar.emptyNone.body": "Escolha o que controlar em Insumos e depois conte aqui.",
    "cs.contar.emptyNone.go": "Ir para Insumos",
    "cs.contar.emptyFilter": "Nada para mostrar com este filtro.",
    "cs.contar.emptySearch": "Nenhum insumo com esse nome.",
    "cs.contar.onlyIds": "Contando {n} de {total}.",
    "cs.contar.allLink": "Contar todos",
    "cs.contar.partial.one": "1 foi salvo; toque em Tentar de novo para o resto.",
    "cs.contar.partial.other": "{n} foram salvos; toque em Tentar de novo para o resto.",
    "cs.contar.done.saved.one": "Salvamos 1 contagem.",
    "cs.contar.done.saved.other": "Salvamos {n} contagens.",
    "cs.contar.done.mins.one": "Salvamos 1 aviso.",
    "cs.contar.done.mins.other": "Salvamos {n} avisos.",
    "cs.contar.done.missing": "Faltaram {plata} desde a última contagem (o que foi jogado fora sem anotar ou usado a mais).",
    "cs.contar.done.extra": "Sobraram {plata} em relação ao que calculávamos.",
    "cs.contar.done.same": "Tudo bateu com o que calculávamos.",
    "cs.contar.done.worstA": "O que mais pesou:",
    "cs.contar.done.replace": "A contagem substitui o que o sistema calculava. Daqui em diante, cada venda desconta deste número.",
    "cs.contar.done.later.one": "1 número não foi salvo: esse insumo já tinha sido contado depois.",
    "cs.contar.done.later.other": "{n} números não foram salvos: esses insumos já tinham sido contados depois.",
    "cs.contar.done.ok": "Pronto",
    "cs.contar.inicial.done": "Pronto: cada venda desconta.",
    "cs.contar.step3.title": "Último passo: o que acontece quando algo esgota?",
    "cs.contar.step3.switch": "Não deixar vender o esgotado",
    "cs.contar.step3.on": "O garçom não consegue lançar um prato esgotado.",
    "cs.contar.step3.off": "O garçom vê \"Esgotado\", mas consegue lançar mesmo assim.",
    "cs.contar.step3.later": "Você pode mudar quando quiser em Ajustes.",
    "cs.contar.step3.saved": "Salvo",

    "cs.perdida.title": "Anotar perda",
    "cs.perdida.pick.intro": "O que se perdeu?",
    "cs.perdida.pick.search": "Buscar insumo…",
    "cs.perdida.pick.emptyT": "Você não controla nenhum insumo",
    "cs.perdida.pick.empty": "As perdas se anotam nos insumos que você controla. Escolha quais em Insumos.",
    "cs.perdida.pick.none": "Nenhum insumo com esse nome.",
    "cs.perdida.pick.notTracked": "{name} não é controlado: escolha um dos que são.",
    "cs.perdida.hay": "Tem {qty}",
    "cs.perdida.hayOversold": "Vendeu-se a mais",
    "cs.perdida.haySinContar": "Sem contagem",
    "cs.perdida.change": "Trocar",
    "cs.perdida.qty": "Quanto se perdeu?",
    "cs.perdida.unitAria": "Unidade",
    "cs.perdida.why": "Por quê?",
    "cs.perdida.reason.vencio": "Venceu",
    "cs.perdida.reason.quemo": "Queimou",
    "cs.perdida.reason.cayo": "Caiu",
    "cs.perdida.reason.otro": "Outro",
    "cs.perdida.otherPh": "Conte o que aconteceu (opcional)",
    "cs.perdida.otherAria": "O que aconteceu",
    "cs.perdida.moneyA": "São",
    "cs.perdida.moneyB": "que se foram.",
    "cs.perdida.noPrice": "Não tem preço: não sabemos quanto dinheiro é.",
    "cs.perdida.more": "É mais do que tem ({qty}).",
    "cs.perdida.err.bad": "Não entendemos esse número.",
    "cs.perdida.err.zero": "Tem que ser mais que 0.",
    "cs.perdida.save": "Salvar perda",
    "cs.perdida.saved": "Você anotou {qty} de {name} ({plata}).",
    "cs.perdida.savedNoPrice": "Você anotou {qty} de {name}.",
    "cs.perdida.noStock": "As perdas se anotam com o estoque do pack Gestão.",

    "cs.activar.title": "Controle seu estoque em 3 passos",
    "cs.activar.stepsAria": "Passos para controlar o estoque",
    "cs.activar.step1": "O que controlar",
    "cs.activar.step2": "Contar o que tem",
    "cs.activar.step3": "Não vender o esgotado",
    "cs.activar.sub": "Marcamos os que seus pratos com receita usam, primeiro os que mais movimentam dinheiro.",
    "cs.activar.noRecipes": "Ainda nenhum prato tem receita, e sem receita a venda não desconta. Custeie seus pratos e volte.",
    "cs.activar.noIngredients": "Para controlar o estoque, primeiro você precisa de insumos: registre uma compra ou custeie um prato.",
    "cs.activar.loadCompra": "Registrar compra",
    "cs.activar.groupAria": "Insumos para controlar",
    "cs.activar.pick.one": "{name} · 1 prato",
    "cs.activar.pick.other": "{name} · {n} pratos",
    "cs.activar.pick.none": "{name} · nenhum prato",
    "cs.activar.showMore": "Ver mais {n}",
    "cs.activar.unused.one": "1 insumo que não está em nenhum prato",
    "cs.activar.unused.other": "{n} insumos que não estão em nenhum prato",
    "cs.activar.unusedHint": "Os que não estão em nenhum prato só baixam com o que você lançar à mão.",
    "cs.activar.drinks.one": "1 bebida do seu cardápio não tem custo. Custeie \"como vem\" para que desconte.",
    "cs.activar.drinks.other": "{n} bebidas do seu cardápio não têm custo. Custeie \"como vem\" para que descontem.",
    "cs.activar.drinksSee": "Ver quais",
    "cs.activar.count.one": "1 escolhido",
    "cs.activar.count.other": "{n} escolhidos",
    "cs.activar.goNone": "Escolha pelo menos um",
    "cs.activar.go": "Seguir com {n}",
  },
};

export default compra;
